export default "__VITE_ASSET__DyZtbkx1__"